module.exports = __webpack_public_path__ + "img/20210906-1630913591966523.98f67b07.png";